import { z } from "zod";

const userAvatarSchema = z.object({
  avatarUrl: z
    .string()
    .refine((val) => !val || z.string().url().safeParse(val).success, {
      message: "Invalid URL format",
    })
    .optional(),
});
type UserAvatarFormData = z.infer<typeof userAvatarSchema>;

export { userAvatarSchema };
export type { UserAvatarFormData };
